export default {
    title: 'Trenduniverse update',
    content: {
        1: 'I would like to always automatically apply all updates to the trend universe.',
        2: 'You can reverse this decision at any time.'
    },
    action: {
        cancel: 'Cancel',
        submit: 'Submit'
    }
}
